// Shared between the homepage server component (price fetch) and the client
// gallery. Must stay a plain module: importing values from a "use client"
// file into an RSC yields client-reference proxies, not the data.

export type OwnerPopularGalleryItem = {
  /** Public path under /images. */
  src: string;
  /** Descriptive alt text, no brand-forbidden terms. */
  alt: string;
  /** Exact menu item name (as stored in menu_items) for the shoppable card. */
  menuName: string;
};

// Ordered by visual appeal (most craveable photography first): the molten
// cheese-pull pizza leads, then the char-and-color plates; the burger shot
// (patty hidden behind fries) and the greens bowl anchor the end.
export const GALLERY_ITEMS: OwnerPopularGalleryItem[] = [
  {
    src: "/images/tuscan-cove-cheese-pizza-table.jpg",
    alt: "A bubbling, golden cheese pizza fresh from the oven on the table at Tuscan Cove Bar & Patio.",
    menuName: "Cheese",
  },
  {
    src: "/images/tuscan-cove-shrimp-skewers.png",
    alt: "Char-grilled shrimp skewers brushed with herbs and lemon, plated for the patio.",
    menuName: "Grilled Shrimp Skewers",
  },
  {
    src: "/images/menu/tuscan-cove-carne-asada.jpg",
    alt: "Carne asada plated with charred peppers and fresh garnish at Tuscan Cove.",
    menuName: "*Carne Asada",
  },
  {
    src: "/images/menu/tuscan-cove-chicken-wings.jpg",
    alt: "A pile of crispy chicken wings tossed in sauce, ready to share.",
    menuName: "Chicken Wings 8pc",
  },
  {
    src: "/images/menu/tuscan-cove-double-smash-burger.jpg",
    alt: "A juicy double smash burger with melted cheese and crisp lettuce on a toasted bun.",
    menuName: "*Double Smash Burger",
  },
  {
    src: "/images/menu/tuscan-cove-italian-chop.jpg",
    alt: "The Italian Chop salad with salami, mozzarella, and crisp greens at Tuscan Cove.",
    menuName: "Italian Chop",
  },
];

/** Menu names the homepage server component fetches pricing for. */
export const POPULAR_GALLERY_MENU_NAMES = GALLERY_ITEMS.map(
  (item) => item.menuName,
);

// Leading "*" is the menu's consumer-advisory marker, not part of the name a
// guest would recognize.
export function normalizeMenuName(value: string): string {
  return value.replace(/^\*/, "").trim().toLowerCase();
}

export function displayMenuName(value: string): string {
  return value.replace(/^\*/, "").trim();
}
